// #ux-redesign-start: imperative toast API — bridge a Radix Toast
// La codebase tiene 40+ archivos usando `toast.success(msg)` / `toast.error`
// estilo react-toastify (API imperativa). Para no tener que refactorar
// todos a un patron declarativo, exponemos la misma API pero bajo Radix.
// El <Toaster> escucha al store y renderiza con @radix-ui/react-toast.
//
// Migracion: cambiar `import { toast } from 'components/ds'` por
// `import { toast } from 'components/ds'`. El resto del codigo queda igual.
//
// PORTABILIDAD: idéntico para Web-Patients.
// ─────────────────────────────────────────────────────────────────────────────

let listeners = [];
let idCounter = 0;

const emit = (event) => {
  listeners.forEach((l) => l(event));
};

export const subscribeToToasts = (cb) => {
  listeners.push(cb);
  return () => {
    listeners = listeners.filter((l) => l !== cb);
  };
};

const makeToast = (type) => (message, options = {}) => {
  const id = ++idCounter;
  emit({
    kind: 'add',
    toast: {
      id,
      type,
      message,
      duration: options.autoClose ?? options.duration ?? 4500,
      ...options,
    },
  });
  return id;
};

const dismiss = (id) => {
  if (id == null) {
    emit({ kind: 'clear' });
  } else {
    emit({ kind: 'dismiss', id });
  }
};

// API compatible con react-toastify: `toast("msg")`, `toast.success("msg")`,
// `toast.error`, `toast.warning`, `toast.warn`, `toast.info`, `toast.dismiss`.
export const toast = Object.assign(
  (message, opts) => makeToast('default')(message, opts),
  {
    success: makeToast('success'),
    error: makeToast('error'),
    warning: makeToast('warning'),
    warn: makeToast('warning'),
    info: makeToast('info'),
    dark: makeToast('default'),
    dismiss,
    // No-op para compatibilidad con `toast.configure({...})` del legacy.
    configure: () => {},
  }
);

export default toast;
// #ux-redesign-end
